import React from 'react';
import { Log } from '../../../../types/logs';

export const GenericLogEvent: React.FunctionComponent<{ log: Log }> = ({ log }) => <div>{log.type}</div>;
export default { element: GenericLogEvent };
